module.exports = __webpack_public_path__ + "img/Cubs.49f4fe5c.png";